module.exports = __webpack_public_path__ + "e6aabbd55ef6e4b38398d11e86733867.svg";